import { defineTreeFilter } from '../engine/descriptor';
import type { FilterDefinition } from '../engine/types';
import { FilterId, FilterType, type TreeFilter } from '../types/filters';

export const customSkillDescriptor = defineTreeFilter({
  definition: {
    id: FilterId.CUSTOM_SKILL,
    name: 'Skill',
    selectionListIds: ['skill_0', 'skill_1', 'skill_2', 'skill_3'],
    selections: [],
    type: FilterType.TREE,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_CUSTOM_SKILL },
  handler: { getRequiredSelectionListIds: () => [] },
});

export const customSkillDefinition: FilterDefinition<TreeFilter> =
  customSkillDescriptor.definition;
